import { BaseFontSize } from "../../Typography";

export enum LogoSizes {
  ExtraSmall = 1 * BaseFontSize,
  Small = 2 * BaseFontSize,
  Medium = 4 * BaseFontSize,
  Large = 6 * BaseFontSize,
  ExtraLarge = 10 * BaseFontSize,
}
